import { Alert } from '@components'
import { InfoIcon } from 'lucide-solid'
import { Show } from 'solid-js'
import { useService } from 'solid-services'
import { useSingle } from '../state'

export default function () {
	const { isArchived } = useService(useSingle)()

	return (
		<Show when={isArchived()}>
			<Alert.Root borderColor="#ffb100">
				<Alert.Icon
					asChild={(iconProps) => (
						<InfoIcon
							color="#ffb100"
							{...iconProps()}
						/>
					)}
				/>
				<Alert.Content>
					<Alert.Title>Archived Setup</Alert.Title>
					<Alert.Description>
						The functionality of this setup is severely limited as it has been marked as
						archived
					</Alert.Description>
				</Alert.Content>
			</Alert.Root>
		</Show>
	)
}
